export const BOOKING_LIST_REQUEST = 'BOOKING_LIST_REQUEST';
export const BOOKING_LIST_SUCCESS = 'BOOKING_LIST_SUCCESS';
export const BOOKING_LIST_FAIL = 'BOOKING_LIST_FAIL';

export const BOOKING_CANCEL_REQUEST = 'BOOKING_CANCEL_REQUEST';
export const BOOKING_CANCEL_SUCCESS = 'BOOKING_CANCEL_SUCCESS';
export const BOOKING_CANCEL_FAIL = 'BOOKING_CANCEL_FAIL';
export const BOOKING_CANCEL_RESET = 'BOOKING_CANCEL_RESET';

export const BOOKING_DELETE_REQUEST = 'BOOKING_DELETE_REQUEST';
export const BOOKING_DELETE_SUCCESS = 'BOOKING_DELETE_SUCCESS';
export const BOOKING_DELETE_FAIL = 'BOOKING_DELETE_FAIL';
export const BOOKING_DELETE_RESET = 'BOOKING_DELETE_RESET';

export const AVAILABILITY_LIST_REQUEST = 'AVAILABILITY_LIST_REQUEST';
export const AVAILABILITY_LIST_SUCCESS = 'AVAILABILITY_LIST_SUCCESS';
export const AVAILABILITY_LIST_FAIL = 'AVAILABILITY_LIST_FAIL';

export const AVAILABILITY_CREATE_REQUEST = 'AVAILABILITY_CREATE_REQUEST';
export const AVAILABILITY_CREATE_SUCCESS = 'AVAILABILITY_CREATE_SUCCESS';
export const AVAILABILITY_CREATE_FAIL = 'AVAILABILITY_CREATE_FAIL';
export const AVAILABILITY_CREATE_RESET = 'AVAILABILITY_CREATE_RESET';

export const AVAILABILITY_UPDATE_REQUEST = 'AVAILABILITY_UPDATE_REQUEST';
export const AVAILABILITY_UPDATE_SUCCESS = 'AVAILABILITY_UPDATE_SUCCESS';
export const AVAILABILITY_UPDATE_FAIL = 'AVAILABILITY_UPDATE_FAIL';
export const AVAILABILITY_UPDATE_RESET = 'AVAILABILITY_UPDATE_RESET';

export const AVAILABILITY_DELETE_REQUEST = 'AVAILABILITY_DELETE_REQUEST';
export const AVAILABILITY_DELETE_SUCCESS = 'AVAILABILITY_DELETE_SUCCESS';
export const AVAILABILITY_DELETE_FAIL = 'AVAILABILITY_DELETE_FAIL';
export const AVAILABILITY_DELETE_RESET = 'AVAILABILITY_DELETE_RESET';

export const AVAILABILITY_BULK_CREATE_REQUEST = 'AVAILABILITY_BULK_CREATE_REQUEST';
export const AVAILABILITY_BULK_CREATE_SUCCESS = 'AVAILABILITY_BULK_CREATE_SUCCESS';
export const AVAILABILITY_BULK_CREATE_FAIL = 'AVAILABILITY_BULK_CREATE_FAIL';
export const AVAILABILITY_BULK_CREATE_RESET = 'AVAILABILITY_BULK_CREATE_RESET';
